import { useEffect, useState, useMemo } from '@wordpress/element';
import { API } from '../API';
import { TableIndex } from './TableIndex';
import { TableContent } from './TableContent';
import { SearchForm } from './SearchForm';

export default function TableComercios() {
  const apiComercios = new API();
  const defaultArgs = {
    posts_per_page: 9999,
    filterByTaxonomy: false,
    groupBy: 'first_letter',
  };

  const [limit, setLimit] = useState(3);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);  // More intuitive than `false`
  const [allComercios, setAllComercios] = useState({});
  const [comerciosIndex, setComerciosIndex] = useState([]);
  const [showReset, setShowReset] = useState(false);

  const onIndexClick = (event) => {
    event.preventDefault();

    if(event.currentTarget.classList.contains('is-disabled')) {
      return;
    }

    const index = event.target.getAttribute('data-index');
    setSelectedIndex(index);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const query = {
      ...defaultArgs,
      search: formData.get('search'),
    };

    apiComercios.loadContent(query).then(response => {
      const data = response.data || {};
      setAllComercios(data);
      setComerciosIndex(Object.keys(data));
      setSelectedIndex(null);
      setShowReset(true);
    });
  }

  const onResetQuery = (event) => {
    event.preventDefault();
    apiComercios.loadContent(defaultArgs).then(response => {
      const data = response.data || {};
      setAllComercios(data);
      setComerciosIndex(Object.keys(data));
      setSelectedIndex(null);
      setShowReset(false);
      setSearchQuery('');
    });
  }

  useEffect(() => {
    const query = {
      posts_per_page: 9999,
      filterByTaxonomy: false,
      groupBy: 'first_letter',
    };

    apiComercios.loadContent(query).then(response => {
      const data = response.data || {};
      setAllComercios(data);
      setComerciosIndex(Object.keys(data));
    });
  }, []);

  const limitedComercios = useMemo(() => {
    return Object.entries(allComercios).slice(0, limit);
  }, [allComercios, limit]);

  const renderComercios = useMemo(() => {

    if (selectedIndex) {
      const selectedComercios = allComercios[selectedIndex];
      return selectedComercios ? (
        <TableContent key={selectedIndex} comerciosKey={selectedIndex} comercios={selectedComercios} />
      ) : null;
    }

    return limitedComercios.map(([key, value]) => (
      <TableContent key={key} comerciosKey={key} comercios={value} />
    ));
  }, [selectedIndex, allComercios, limitedComercios]);

  return (
    <>
      <SearchForm searchQuery={searchQuery} setSearchQuery={setSearchQuery} onSubmit={onSubmit} onResetQuery={onResetQuery} showReset={showReset} />
      <TableIndex comerciosIndex={comerciosIndex} selectedIndex={selectedIndex} onIndexClick={onIndexClick} />
      {renderComercios}
    </>
  );
}
